<sb-sidebar [title]="title()" [class.pb-lg]="showChargebeeTestButtons()" [labsLayout]="true">
  <ul sb-sidebar-list [ariaLabel]="title()">
    @for (item of menuItems(); track $index) {
      @if (item.items?.length > 0) {
        <li sb-sidebar-accordion-item [expanded]="groupIsExpanded(item)">
          <a
            sb-sidebar-item
            [icon]="item.state?.isLocked ? 'lock-regular' : item.sbIcon"
            iconSize="xl"
            [routerLink]="getGroupItemLink(item)"
            [locked]="item.state?.isLocked"
            (click)="onItemClick(item)"
          >
            {{ item.label | translate }}
          </a>

          <sb-sidebar-accordion-body>
            @for (subItem of item.items; track $index) {
              <li>
                <ng-container *ngTemplateOutlet="sidebarItem; context: { $implicit: subItem }" />
              </li>
            }
          </sb-sidebar-accordion-body>
        </li>
      } @else {
        <li>
          <ng-container *ngTemplateOutlet="sidebarItem; context: { $implicit: item }" />
        </li>
      }
    }
  </ul>

  <ng-template #sidebarItem let-sidebarItem>
    <!-- HACK: to have at least some proper typing -->
    @let item = toSidebarItem(sidebarItem);
    <a
      sb-sidebar-item
      [icon]="item.state?.isLocked ? 'lock-regular' : item.sbIcon"
      [routerLink]="item.state?.isLocked ? null : [item.routerLink]"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="item.routerLinkActiveOptions"
      #rla="routerLinkActive"
      [active]="rla.isActive"
      [locked]="item.state?.isLocked"
      (click)="onItemClick(item)"
    >
      {{ item.label | translate }}
    </a>
  </ng-template>

  @if (showChargebeeTestButtons()) {
    <div class="mt-auto flex flex-col gap-sm" sb-sidebar-bottom-list>
      <button sb-button color="primary" (click)="onImportChargeBee()">
        {{ 'Import from ChargeBee' | translate }}
      </button>
      <button sb-button color="primary" (click)="onPushChargeBee()">
        {{ 'Push to ChargeBee' | translate }}
      </button>
    </div>
  }
</sb-sidebar>
